import { render, staticRenderFns } from "./TaxonomyUpdate.vue?vue&type=template&id=045e9946&"
import script from "./TaxonomyUpdate.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports